import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

function PatientDashboardTabs({ onTabChange, name }) {
  const [activeTab, setActiveTab] = useState(name);
  const navigate = useNavigate();

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    if (tab === "visits") {
      // Load visits

      navigate('/patient-dashboard');
    }

     if (tab === "bookapt") {
      // Load visits

      navigate('/request-appointment');
    }

    if (tab === "profile") {
      // Load visits

      navigate('/patient-profile');
    }


    //onTabChange(tab);
  };

  return (
    <ul className="nav custom-tabs">
      <li className="nav-item" style={{ borderBottom: `${activeTab === "visits" ? "3px solid #0f4c81" : "none"}` }}>
        <button
          className={`nav-link ${activeTab === "visits" ? "" : ""}`}
          onClick={() => handleTabChange("visits")}
        >
          Visits
        </button>
      </li>

     <li className="nav-item" style={{ borderBottom: `${activeTab === "profile" ? "3px solid #0f4c81" : "none"}` }}>
        <button
          className={`nav-link ${activeTab === "profile" ? "" : ""
            }`}
          onClick={() => handleTabChange("profile")}
        >
          Profile
        </button>
      </li>

      <li className="nav-item" style={{ borderBottom: `${activeTab === "bookapt" ? "3px solid #0f4c81" : "none"}` }}>
        <button
          className={`nav-link ${activeTab === "bookapt" ? "" : ""
            }`}
          onClick={() => handleTabChange("bookapt")}
        >
          Book Appointment
        </button>
      </li>
    </ul>
  );
}
export default PatientDashboardTabs;
